module.exports = __webpack_public_path__ + "static/zoma_pannonia_adatkezeles-cda0aeb27a1564349d04212cf9acfef7.pdf";